module.exports = __webpack_public_path__ + "media/images/marble-page-wrap-2-4f49d1898e49ace9b8b532685b4da188.jpg";